import { PressResponder } from '@react-aria/interactions'
import { PropsWithChildren, useCallback } from 'react'
import { LiveHelpTriggerProps } from 'components/LiveHelpButton/Types'
import { mergeProps } from '@react-aria/utils'

export const LiveHelpTrigger = ({ children, message, ...pressProps }: PropsWithChildren<LiveHelpTriggerProps>) => {
  const handlePress = useCallback(() => {
    return window.Intercom('showNewMessage', message)
  }, [message])

  return (
    <PressResponder {...mergeProps({ onPress: handlePress }, pressProps)}>
      {children}
    </PressResponder>
  )
}
